<div class="container">
  <ng-template #loading>
    <div style="text-align:center; font-size:30px; padding:5%">
      <i class="fa fa-spinner fa-pulse"></i>
    </div>
  </ng-template>
</div>
